var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"50px","height":"50px"}},[_c('circle',{staticClass:"progress-circle",attrs:{"cx":"25","cy":"25","r":"20","fill":"transparent","stroke":"green","stroke-width":"3","stroke-dashoffset":_vm.progres}})])}
var staticRenderFns = []

export { render, staticRenderFns }